import React, {useEffect, useState} from "react";
import {VisitDateComponent, VisitDateComponent2} from "../visit-application/visit-date";
import VisitTimeComponent from "../visit-application/visit-time";
import FindSiteComponent from "../visit-application/find-site";
import FindMapComponent from "../visit-application/find-map";
import FindHostComponent from "../visit-application/find-host";
import VisitorInfoComponent from "../visit-application/visitor-Info";
import {isValidPhoneNumber, isValidBirthDay, isValidCarNumber} from '../visit-application/visit-valid';
import {constructVisitorInfo, VisitorApplicationInfo, VisitorInfo} from "../../interface/model/visitor";
import Api from "../../interface/api/visit";
import {EquipmentInfo, StuffInfo} from "../../interface/model/visitorExtends";
import {SiteInfo} from "../../interface/model/site";
import {BlueButton} from "../../component/button";


interface localVisitorInfo {
    visitorInfo:VisitorInfo
    equipmentInfo?:EquipmentInfo,
    stuffInfos?:Array<StuffInfo>,
    visitorTermsInfos?:Array<any>
}


export default function Form({props, visitorTermsInfos, visitorInfo, completeHandler}) {

    const [ siteInfo, setSiteInfo ] = useState<SiteInfo>();

    const [ locationArea, setLocationArea ] = useState({area2_state : false, area3_state : false, area4_state : false, area5_state : false});
    const [ addedVisitLocations, setAddedVisitLocations ] = useState({area2_location : '', area3_location : '', area4_location : '', area5_location : ''});
    const [ visitorApplicationInfo, setVisitorApplicationInfo ] = useState<VisitorApplicationInfo>();

    const [ visitorInfos, setVisitorInfos ] = useState<Array<localVisitorInfo>>([{
        visitorInfo:{...constructVisitorInfo, standardFlag:true},
        visitorTermsInfos:visitorTermsInfos
    }]);

    const [ certificateFlag, setCertificateFlag ] = useState(true);


    function submit() {
        let valid = true;
        let completeLocationStr;

        // 방문자 입력 검증
        for (const { visitorInfo } of visitorInfos) {
            const { birthDay, phone, carFlag, car } = visitorInfo;

            if (!isValidBirthDay(birthDay)) {
                alert(`생년월일을 확인해주세요.\r\n ex) 19910101`);
                valid = false;
            }
            if (!isValidPhoneNumber(phone)) {
                alert(`연락처를 확인해주세요.\r\n ex) 01011112222`);
                valid = false;
            }
            if (carFlag == 'true' && !isValidCarNumber(car)) {
                alert(`차량번호를 확인해주세요.`);
                valid = false;
            }
        }

        // 방문위치 체크
        const visitLoc = visitorApplicationInfo.visitLocation;
        if (visitLoc !== undefined && visitLoc !== '') {
            const arr = visitLoc.split(',');
            const defaultLocationStr = arr[0] + ',' + arr[1];
            const thereDepthsStr = visitLoc.substring(defaultLocationStr.length + 1);

            const isSLD = siteInfo.name === '솔브레인에스엘디';

            // 첫 위치
            const head = thereDepthsStr.split('/')[0];
            const first = isSLD ? head.substring(5).split('/')[0] : head;

            // 추가 위치들 수집 (조건 충족 시에만 추가)
            const offset = defaultLocationStr.length + (isSLD ? 6 : 1);
            const parts: string[] = [first];
            const pushIf = (enabled: boolean, value?: string) => {
                if (enabled === true && value) parts.push(value.substring(offset));
            };
            pushIf(locationArea.area2_state, addedVisitLocations.area2_location);
            pushIf(locationArea.area3_state, addedVisitLocations.area3_location);
            pushIf(locationArea.area4_state, addedVisitLocations.area4_location);
            pushIf(locationArea.area5_state, addedVisitLocations.area5_location);

            const hasDup = new Set(parts).size !== parts.length;
            if (hasDup) {
                valid = false;
                alert('중복된 방문위치가 존재합니다.');
            } else {
                const joined = parts.join('/');
                completeLocationStr = isSLD
                    ? `${defaultLocationStr},${thereDepthsStr.substring(0, 5)}${joined}`
                    : `${defaultLocationStr},${joined}`;
            }
        } else {
            alert('방문위치를 선택해주세요.');
            valid = false;
        }

        // 저장
        if (valid) {
            Api.createVisitInfo(
                { ...visitorApplicationInfo, visitLocation: completeLocationStr, certificateFlag },
                visitorInfos
            ).then(res => {
                completeHandler(res.data);
            });
        }
    }

    function calcDate(startDate, endDate) {
        let start = new Date(startDate);
        let end = new Date(endDate);

        let calcTime = end.getTime() - start.getTime();
        let resultDate = calcTime/1000/60/60/24 + 1;
        if( resultDate < 30 ) return "장기방문은 최대 6개월까지 신청 가능합니다.(" +resultDate + "일)";
        else return "장기방문은 최대 6개월까지 신청 가능합니다.("+Math.floor(resultDate/30)+"개월 " +Math.floor(resultDate%30) + "일)";
    }

    function checkTime(siteName) {
        let nDate = new Date();
        let today = nDate.getFullYear()+"-"+((nDate.getMonth()+1)<10 ? "0"+(nDate.getMonth()+1) : (nDate.getMonth()+1))+"-"+(nDate.getDate()<10 ? "0"+nDate.getDate() : nDate.getDate());
        let nTime = nDate.getHours();
        let startDate = ( visitorApplicationInfo !== undefined && visitorApplicationInfo.startDate !== undefined ) ? visitorApplicationInfo.startDate : ''
        
        // 2022-08-30 > 솔브레인 김영찬 매니저 요청으로 업데이트
        if( startDate == today ) {
            return nTime;
        }
        return 0;
    }

    function addLocation() {
        if(locationArea.area2_state === false) {
            setLocationArea({...locationArea, area2_state : true});
        } else if(locationArea.area3_state === false) {
            setLocationArea({...locationArea, area3_state : true});
        } else if(locationArea.area4_state === false) {
            setLocationArea({...locationArea, area4_state : true});
        } else if(locationArea.area5_state === false) {
            setLocationArea({...locationArea, area5_state : true});
        } else {
            alert('방문위치는 최대 5개 등록 가능합니다.');
        }
    }

    function delLocation(idx) {
        switch (idx) {
            case 2 :
                setLocationArea({...locationArea, area2_state : false});
                setAddedVisitLocations({...addedVisitLocations, area2_location: ''});
                break;
            case 3 :
                setLocationArea({...locationArea, area3_state : false});
                setAddedVisitLocations({...addedVisitLocations, area3_location: ''});
                break;
            case 4 :
                setLocationArea({...locationArea, area4_state : false});
                setAddedVisitLocations({...addedVisitLocations, area4_location: ''});
                break;
            case 5 :
                setLocationArea({...locationArea, area5_state : false});
                setAddedVisitLocations({...addedVisitLocations, area5_location: ''});
                break;
        }
    }

    useEffect(() => {
        setSiteInfo(JSON.parse(localStorage.getItem('siteInfo')));
        if(props!==undefined && props.location.search === '?type=long') {
            let nDate = new Date();
            let today = nDate.getFullYear()+"-"+((nDate.getMonth()+1)<10 ? "0"+(nDate.getMonth()+1) : (nDate.getMonth()+1))+"-"+(nDate.getDate()<10 ? "0"+nDate.getDate() : nDate.getDate());
            setVisitorApplicationInfo({...visitorApplicationInfo, longTermFlag : true, startDate : today, endDate : today});
        }
    }, [])

    return (
        <section id="step2" className="visitor_info">
            <div className="nv_tablebox">
                <div className="nv_table_tit">
                    <h2>방문 정보</h2>
                </div>
                <table className="nv_table" cellPadding="0" cellSpacing="0">
                    <tbody>
                    <tr>
                        <td className="gray textcenter">방문기간</td>
                        <td colSpan={2}>
                            {
                                visitorApplicationInfo !== undefined && visitorApplicationInfo.longTermFlag
                                    ? <div className="period_box">
                                        <VisitDateComponent2 selectedHandler={
                                            (date) =>
                                                setVisitorApplicationInfo({...visitorApplicationInfo, startDate:date})
                                        }/>
                                        <VisitDateComponent2 selectedHandler={
                                            (date) =>
                                                setVisitorApplicationInfo({...visitorApplicationInfo, endDate:date})
                                        }/>
                                        <span style={{margin:'5px 5px', fontSize:'12.5px'}}>{calcDate(visitorApplicationInfo.startDate, visitorApplicationInfo.endDate)}</span>
                                    </div>
                                    : <div className="period_box">
                                        <VisitDateComponent selectedHandler={
                                            (date) =>
                                                setVisitorApplicationInfo({...visitorApplicationInfo, startDate:date, endDate:date})
                                        }/>
                                    </div>
                            }
                        </td>
                    </tr>
                    <tr>
                        <td className="gray textcenter">방문시간</td>
                        <td colSpan={2}>
                            {/* 2022-08-30 > 솔브레인 김영찬 매니저 요청으로 업데이트 */}
                            <VisitTimeComponent
                                placeholder={'입문 시간 선택'}
                                start={checkTime('')}
                                end={22}
                                onChangeHandler={(selectedTime) =>
                                    setVisitorApplicationInfo({...visitorApplicationInfo, startTime:selectedTime })
                                }
                            />
                            <VisitTimeComponent
                                placeholder={'출문 시간 선택'}
                                start={visitorApplicationInfo!==undefined ? visitorApplicationInfo.startTime+1 : 0}
                                end={23}
                                onChangeHandler={(selectedTime) =>
                                    setVisitorApplicationInfo({...visitorApplicationInfo, endTime:selectedTime })
                                }
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="gray textcenter">방문위치</td>
                        <td colSpan={2}>
                            <div>
                                <FindSiteComponent
                                    siteInfo = { JSON.parse(localStorage.getItem('siteInfo')) }
                                    selectedHandler = { (visitLocation) => setVisitorApplicationInfo({...visitorApplicationInfo, visitLocation:visitLocation}) }
                                />
                                <BlueButton
                                    type = { 'button' }
                                    onClickHandler = { addLocation }
                                    innerHTML = { '추가' }
                                />
                                <FindMapComponent siteInfo={ JSON.parse(localStorage.getItem('siteInfo')) } />
                            </div>
                        </td>
                    </tr>
                    {
                        locationArea.area2_state &&
                        <tr>
                            <td className="gray textcenter">방문위치</td>
                            <td colSpan={2}>
                                <div>
                                    <FindSiteComponent
                                        siteInfo = { JSON.parse(localStorage.getItem('siteInfo')) }
                                        selectedHandler = { (visitLocation) => setAddedVisitLocations({...addedVisitLocations, area2_location: visitLocation}) }
                                    />
                                    <button
                                        type = "button"
                                        className = "nv_button_red minus"
                                        onClick = { () => delLocation(2)} >
                                        삭제
                                    </button>
                                </div>
                            </td>
                        </tr>
                    }
                    {
                        locationArea.area3_state &&
                        <tr>
                            <td className="gray textcenter">방문위치</td>
                            <td colSpan={2}>
                                <div>
                                    <FindSiteComponent
                                        siteInfo = { JSON.parse(localStorage.getItem('siteInfo')) }
                                        selectedHandler = { (visitLocation) => setAddedVisitLocations({...addedVisitLocations, area3_location: visitLocation}) }
                                    />
                                    <button
                                        type = "button"
                                        className = "nv_button_red minus"
                                        onClick = { () => delLocation(3)} >
                                        삭제
                                    </button>
                                </div>
                            </td>
                        </tr>
                    }
                    {
                        locationArea.area4_state &&
                        <tr>
                            <td className="gray textcenter">방문위치</td>
                            <td colSpan={2}>
                                <div>
                                    <FindSiteComponent
                                        siteInfo = { JSON.parse(localStorage.getItem('siteInfo')) }
                                        selectedHandler = { (visitLocation) => setAddedVisitLocations({...addedVisitLocations, area4_location: visitLocation}) }
                                    />
                                    <button
                                        type = "button"
                                        className = "nv_button_red minus"
                                        onClick = { () => delLocation(4)} >
                                        삭제
                                    </button>
                                </div>
                            </td>
                        </tr>
                    }
                    {
                        locationArea.area5_state &&
                        <tr>
                            <td className="gray textcenter">방문위치</td>
                            <td colSpan={2}>
                                <div>
                                    <FindSiteComponent
                                        siteInfo = { JSON.parse(localStorage.getItem('siteInfo')) }
                                        selectedHandler = { (visitLocation) => setAddedVisitLocations({...addedVisitLocations, area5_location: visitLocation}) }
                                    />
                                    <button
                                        type = "button"
                                        className = "nv_button_red minus"
                                        onClick = { () => delLocation(5)} >
                                        삭제
                                    </button>
                                </div>
                            </td>
                        </tr>
                    }
                    <tr>
                        <td rowSpan={3} className="gray textcenter">유해화학물질 종사자<br/>교육 대상여부</td>
                        <td colSpan={2}>
                            <input type="radio" name="certificate_check" id="c1_y"
                                   value="true"
                                   onClick={() => setCertificateFlag(true)}
                                   checked={certificateFlag == true ? true : false}/>
                            <label htmlFor="c1_y">대상</label>
                            <input type="radio" name="certificate_check" id="c1_n"
                                   value="false"
                                   onClick={() => setCertificateFlag(false)}
                                   checked={certificateFlag == false ? true : false}/>
                            <label htmlFor="c1_n">비대상</label>
                        </td>
                    </tr>
                    <tr>
                        <td style={{textAlign:'center'}}>
                            {/*{*/}
                            {/*    visitorApplicationInfo !== undefined && visitorApplicationInfo.longTermFlag ?*/}
                            {/*        <img src={"/resource/user/images/long.png"} style={{width:'75%'}} /> : <img src={"/resource/user/images/normal.png"} style={{width:'75%'}} />*/}
                            {/*}*/}
                            <img src={"/resource/user/images/certificate.PNG"} style={{width:'75%'}} />
                        </td>
                    </tr>
                    <tr>
                        <td className="certificate_box">
                            ※ 중대재해처벌법 강화로 인하여 당사 내방 시 특정 방문 대상일 경우 <strong>유해화학물질 종사자 교육에 대한 수료증 업로드가 필수 사항</strong>입니다.
                            <p>( 대상 여부가 궁금하신 분은 솔브레인 ESH경영팀 오민규 매니저 (041-840-0313)에게 연락 부탁드립니다. )</p>
                        </td>
                    </tr>
                    <tr className="gray textcenter">
                        <td className="gray textcenter">방문목적</td>
                        <td colSpan={2  }>
                            <div className="period_box">
                                <select name="visitPurpose" className="nv_select_box"
                                        onChange={
                                            (e) =>
                                                setVisitorApplicationInfo({...visitorApplicationInfo, visitPurpose:e.target.value})
                                        }
                                >
                                    <option selected={true} disabled={true}>선택</option>
                                    {
                                        certificateFlag ?
                                            JSON.parse(localStorage.getItem('siteInfo')).siteVisitPurposeInfos !== undefined &&
                                                JSON.parse(localStorage.getItem('siteInfo')).siteVisitPurposeInfos.map((row, index) => (
                                                <option key={`siteVisitPurposeInfosKey-${index}`} value={row.name}>{row.name}</option>
                                            )) :
                                            <>
                                                <option value="면접">면접</option>
                                                <option value="택배/우편">택배/우편</option>
                                                <option value="건강검진">건강검진</option>
                                                <option value="작업환경측정">작업환경측정</option>
                                                <option value="관공서">관공서</option>
                                                <option value="회의">회의</option>
                                                <option value="단순납품">단순납품</option>
                                                <option value="기타">기타</option>
                                            </>
                                    }
                                </select>
                                <textarea
                                    className="visitPurposeDetail"
                                    name="visitPurposeDetail"
                                    id="visitPurposeDetail"
                                    onChange={
                                        (e) =>
                                            setVisitorApplicationInfo({...visitorApplicationInfo, visitPurposeDetail:e.target.value})
                                    }
                                    required={true}
                                    placeholder="방문상세목적"/>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="nv_tablebox">
                <div className="nv_table_tit">
                    <h2>접견인 정보</h2>
                </div>
                <table className="nv_table" cellPadding="0" cellSpacing="0">
                    <tbody>
                    <tr>
                        <td className="gray textcenter">접견인</td>
                        <td colSpan={3}>
                            <FindHostComponent onClickHandler={
                                (hostInfo) =>
                                    setVisitorApplicationInfo({...visitorApplicationInfo, hostInfo:hostInfo})}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <VisitorInfoComponent
                visitorInfos = { visitorInfos }
                setVisitorInfos = { setVisitorInfos }
                componentType = { 0 }
                certificateFlag={ certificateFlag }
            />
            <div className="nv_btn_area">
                <button type="button" className="nv_btn_blue" onClick={submit}>신청</button>
            </div>
        </section>
    )
}